import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
	BUTTON_TYPES,
	CaretDownIcon,
	DropdownPosition,
	EvDropdownMenu,
	EvIcon,
	EvSpinner,
	IDropdownMenuOption
} from '@evinced-private/ui-common';

import { getViewsOptionsList as createViewsOptionsList } from '../../../helpers/PropertyViewsHelper';
import { RoutesHelper } from '../../../helpers/RoutesHelper';
import { IPropertyView } from '../../../interfaces/PropertyViews';
import {
	IPropertyViewContext,
	usePropertyViewContext
} from '../../../providers/PropertyViewProvider';
import { useUserTenant } from '../../../providers/userTenantProvider/UserTenantProvider';

import { ALL_CONTENT_VIEW, manageViewsButtonTitle } from './consts/PropertyViews';

import './EvPropertyViews.scss';

interface IEvPropertyViewsProps {
	propertyId: string;
}

export const EvPropertyViews: React.FC<IEvPropertyViewsProps> = ({ propertyId }) => {
	const propertyViewContext: IPropertyViewContext = usePropertyViewContext();
	const currentViewName: string = propertyViewContext.currentView?.name || 'Select';
	const history = useHistory();
	const { isReadOnlyUser } = useUserTenant();

	const [propertyViewsOptions, setPropertyViewsOptions] = useState<IDropdownMenuOption[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const onOptionChange = useCallback(
		async (view: IPropertyView): Promise<void> => {
			await propertyViewContext.updateSelectedView(view);
		},
		[propertyViewContext]
	);

	const getViewsOptionsList = useCallback((): void => {
		const viewsOptions: IDropdownMenuOption[] = createViewsOptionsList(
			[ALL_CONTENT_VIEW, ...propertyViewContext.propertyViews],
			onOptionChange
		);

		setPropertyViewsOptions(viewsOptions);
		setIsLoading(false);
	}, [propertyViewContext.propertyViews, onOptionChange]);

	useEffect(() => {
		getViewsOptionsList();
	}, [getViewsOptionsList]);

	return (
		<div className="filtered-views">
			<div className="views-list-label">Views</div>
			{isLoading ? (
				<EvSpinner />
			) : (
				<EvDropdownMenu
					id="manage-views"
					position={DropdownPosition.BOTTOM_LEFT}
					options={[...propertyViewsOptions]}
					className="manage-views"
					stickyButtons={
						!isReadOnlyUser() && [
							{
								title: manageViewsButtonTitle,
								type: BUTTON_TYPES.PRIMARY,
								onClick: () => {
									history.push(RoutesHelper.getManageViewsPath(propertyId));
								},
								isFullWidth: true,
								children: manageViewsButtonTitle
							}
						]
					}
					triggerButtonProps={{
						type: BUTTON_TYPES.GHOST,
						title: `Views selection. Currently on view ${currentViewName}`,
						children: (
							<div aria-hidden="true" className="property-views-list">
								<div className="selected-property-view">{`${currentViewName}`}</div>
								<EvIcon className="down-caret-icon" icon={CaretDownIcon} small />
							</div>
						)
					}}
				/>
			)}
		</div>
	);
};
